import styled, { css } from "styled-components";

import { responsiveness } from "../../assets/styles/parameters";

export const Container = ({ width, margin, children }) => {
  return (
    <BaseContainer width={width} margin={margin}>
      {children}
    </BaseContainer>
  );
};

export default Container;

const BaseContainer = styled.div`
  width: ${({ width }) => (width ? `${width}%` : "100%")};
  ${({ margin }) => {
    switch (margin) {
      case "auto":
        return css`
          margin: auto;
        `;
      default:
        return css`
          margin: auto;
        `;
    }
  }};

  @media screen and (max-width: ${responsiveness.mobile1}) {
    width: 100%;
  }
`;
